{
  "name": "@uppy/core",
  "description": "Core module for the extensible JavaScript file upload widget with support for drag&drop, resumable uploads, previews, restrictions, file processing/encoding, remote providers like Dropbox, Google Drive, S3 and more :dog:",
  "version": "6.3.0",
  "license": "MIT",
  "style": "dist/style.min.css",
  "type": "module",
  "sideEffects": [
    "*.css"
  ],
  "scripts": {
    "build": "tsc --build tsconfig.build.json",
    "build:css": "sass --load-path=../../ src/style.scss dist/style.css && sass --load-path=../../ src/provider-views/style.scss dist/provider-views.css && postcss dist/style.css -u cssnano --map -o dist/style.min.css && postcss dist/provider-views.css -u cssnano --map -o dist/provider-views.min.css",
    "typecheck": "tsc --build",
    "test": "vitest run --silent='passed-only'"
  },
  "keywords": [
    "file uploader",
    "uppy",
    "uppy-plugin"
  ],
  "homepage": "https://uppy.io",
  "bugs": {
    "url": "https://github.com/transloadit/uppy/issues"
  },
  "repository": {
    "type": "git",
    "url": "git+https://github.com/transloadit/uppy.git"
  },
  "files": [
    "src",
    "lib",
    "dist",
    "CHANGELOG.md"
  ],
  "exports": {
    ".": "./lib/index.js",
    "./css/style.min.css": "./dist/style.min.css",
    "./css/style.css": "./dist/style.css",
    "./css/style.scss": "./src/style.scss",
    "./store-default": "./lib/store/index.js",
    "./utils": "./lib/utils/index.js",
    "./utils/preact": "./lib/utils/preact/index.js",
    "./utils/preact/hooks": "./lib/utils/preact/hooks.js",
    "./companion-client": "./lib/companion-client/index.js",
    "./provider-views": "./lib/provider-views/index.js",
    "./provider-views/css/style.min.css": "./dist/provider-views.min.css",
    "./provider-views/css/style.css": "./dist/provider-views.css",
    "./provider-views/css/style.scss": "./src/provider-views/style.scss",
    "./package.json": "./package.json"
  },
  "dependencies": {
    "@transloadit/prettier-bytes": "^2.0.0",
    "classnames": "^2.5.1",
    "lodash": "^4.18.1",
    "mime-match": "^1.0.2",
    "namespace-emitter": "^2.0.1",
    "nanoid": "^6.0.1",
    "p-queue": "^9.3.3",
    "p-retry": "^8.0.0",
    "preact": "^10.29.2"
  },
  "devDependencies": {
    "@types/deep-freeze": "^0",
    "@types/gapi": "^0.0.47",
    "@types/google.accounts": "^0.0.18",
    "@types/google.picker": "^0.0.52",
    "@types/lodash": "^4.17.25",
    "@types/mime-match": "^1.0.0",
    "@types/namespace-emitter": "^2.0.0",
    "@types/node": "^22.20.1",
    "@uppy-dev/tsconfig": "workspace:^",
    "@vitest/browser-playwright": "^5.0.3",
    "cssnano": "^8.0.1",
    "deep-freeze": "^0.0.1",
    "msw": "^3.0.2",
    "playwright": "1.64.0",
    "postcss": "^8.5.23",
    "postcss-cli": "^11.0.1",
    "sass": "^1.89.2",
    "typescript": "^6.0.3",
    "vite": "^8.3.0",
    "vitest": "^5.0.3"
  }
}
